import { Component } from '@angular/core';

@Component({
    selector: 'invalid-license',
    template: `<div class="container-fluid welcome graphic-bg">
    <div class="row" style="min-height:480px;">
        <div class="col-xs-12 col-md-8">
            <div class="jumbotron intro-heading trans">
                <h1 class="text-danger">Invalid License</h1>
                <p class="text-uppercase subhead text-muted" style="margin-top: 1em;">Sorry, the license information is incorrect of out of date.<br />
                    Please contact GForge Support for assistance.</p>
            </div>
        </div>
    </div>
</div>`
})
export class LicenseComponent {
    constructor() { }
}


